import React from 'react';

interface LogoProps {
  /** Size in pixels — applied to both width and height. Defaults to 32. */
  size?: number;
  className?: string;
}

/**
 * CreatorVault SVG logo — hexagon vault shape with play arrow cutout.
 * Uses a purple-to-cyan gradient. Fully scalable via the `size` prop.
 */
const Logo: React.FC<LogoProps> = ({ size = 32, className }) => {
  // Use a unique gradient id per instance to avoid SVG defs collisions
  const gradientId = 'cv-logo-grad';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="CreatorVault logo"
      className={className}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#a855f7" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
      </defs>
      {/* Vault shape — hexagon outline */}
      <path
        d="M16 2L28.66 9.5V24.5L16 30L3.34 24.5V9.5L16 2Z"
        stroke={`url(#${gradientId})`}
        strokeWidth="2"
        fill="none"
      />
      {/* Inner diamond / play arrow */}
      <path d="M13 11L22 16L13 21V11Z" fill={`url(#${gradientId})`} />
    </svg>
  );
};

export default Logo;
